import Modal from "../../common/Modal";
import Avatar from "../../common/Avatar";
import { removeHubPartner } from "../../../services/hubPartnerService";
import { useState } from "react";

const RemovePartnerModal = ({ partner, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRemove = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await removeHubPartner(partner.id);
      if (res.isSuccess) {
        onSuccess();
        onClose();
      } else {
        setError(res.message ?? "Failed to remove partner.");
      }
    } catch (err) {
      setError(err.response?.data?.message ?? "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={!!partner} onClose={onClose} title="Remove Partner">
      <div className="space-y-5">
        {/* Partner info */}
        <div className="flex items-center gap-3 p-3 bg-bg-base rounded-xl border border-border">
          <Avatar
            name={partner?.user?.name}
            surname={partner?.user?.surname}
            image={partner?.user?.image}
            size="md"
          />
          <div>
            <p className="text-sm font-semibold text-text-primary">
              {partner?.user?.name} {partner?.user?.surname}
            </p>
            <p className="text-xs text-text-muted">{partner?.user?.email}</p>
          </div>
        </div>

        <p className="text-sm text-text-secondary">
          Are you sure you want to remove this partner? They will lose access to
          all hub events immediately.
        </p>

        {error && (
          <p className="text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-3 py-2">
            {error}
          </p>
        )}

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl text-sm border border-border text-text-muted hover:border-border-hover transition"
          >
            Cancel
          </button>
          <button
            onClick={handleRemove}
            disabled={loading}
            className="flex-1 py-2.5 rounded-xl text-sm bg-red-500/10 text-red-400 border border-red-500/20 font-semibold hover:bg-red-500/20 transition disabled:opacity-50"
          >
            {loading ? "Removing..." : "Remove Partner"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemovePartnerModal;
